import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductsStart, deleteProductStart } from './../../redux/Products/products.actions';
import LoadMore from './../../components/LoadMore';
import { Link } from 'react-router-dom'
import { database, firestore } from './../../firebase/utils';
import Button from '../../components/forms/Button';
import './styles.scss';


const mapState = ({ productsData }) => ({
  products: productsData.products
});

var nf = new Intl.NumberFormat();


const Admin = props => {
  const { products } = useSelector(mapState);
  const dispatch = useDispatch();

  // const [hideModal, setHideModal] = useState(true);
  // const [category, setProductCategory] = useState('malewears');
  // const [pname, setProductName] = useState('');
  // const [image, setProductImage] = useState(null);
  // const [price, setProductPrice] = useState(0);
  // const [description, setProductDesc] = useState('');
  const { data, queryDoc, isLastPage } = products;

  const [prdaAmount, setPrdAmount] = useState(0);
  firestore.collection("Products").get().then(function (querySnapshot) {
    // alert(querySnapshot.size); 
    setPrdAmount(querySnapshot.size)
  });

  useEffect(() => {
    dispatch(
      fetchProductsStart()
    );
  }, []);

  const handleLoadMore = () => {
    dispatch(
      fetchProductsStart({
        startAfterDoc: queryDoc,
        persistProducts: data
      })
    );
  };

  const configLoadMore = {
    onLoadMoreEvt: handleLoadMore,
  };

  return (
    <div className="admin">

      <div className="manageProducts">
        <div>
          Amount of Products: {prdaAmount}
        </div>
        <table border="0" cellPadding="0" cellSpacing="0">
          <tbody>
            <tr>
              <th>
                <h1>
                  Manage Products
                </h1>
              </th>
            </tr>
            <tr>
              <td>
                <table className="results" border="0" cellPadding="10" cellSpacing="0">
                  <tbody>
                    {(Array.isArray(data) && data.length > 0) && data.map((product, index) => {
                      const {
                        pname,
                        pbrand,
                        pid,
                        image,
                        price,
                        weight,
                        documentID,
                        stockqty
                      } = product;

                      return (
                        <>
                          <tr key={index}>
                            <Link to={`/editproduct/${documentID}`}>
                              {/* <td>
                                {pbrand}
                              </td> */}

                              <td className="thumb">
                                <span className="pid-container">
                                  <span className="pid">{pid}</span>
                                  <span className="brand">{pbrand}</span>
                                </span>
                                <img src={image} />
                              </td>

                              <td className='sep'>
                                <td>
                                  {pname}
                                </td>
                                <td className='inner-sep'>
                                  <td>
                                    {'\u20A6'}{nf.format(price)}
                                  </td>
                                  <td className='fill'>
                                    Qty: {stockqty}
                                  </td>
                                  <td className='fill'>
                                    KG: {weight}
                                  </td>
                                </td>
                              </td>

                              <td>

                                <Button onClick={() => dispatch(deleteProductStart(documentID))}>
                                  Delete
                                </Button>
                              </td>
                            </Link>
                          </tr>
                        </>
                      )
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>

              </td>
            </tr>
            <tr>
              <td>
                <table border="0" cellPadding="10" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td>
                        {!isLastPage && (
                          <LoadMore {...configLoadMore} />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>
  );
}

export default Admin;